
import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroContent from '@/components/hero/HeroContent';
import HeroSearch from '@/components/hero/HeroSearch';

const HeroSection: React.FC = () => {
  const regionTexts = [
    'Himalayan',
    'Karnataka',
    'Uttarakhand',
    'Himachal Pradesh',
    'Kashmir',
    'Western Ghats',
    'Northeast India'
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "GoTrekking",
    "url": "https://gotrekking.in",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://gotrekking.in/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "description": "Find and compare the best trek packages from top adventure companies, all in one place."
  };

  return (
    <section className="relative py-20 md:py-28 px-4 overflow-hidden bg-gradient-to-b from-background to-muted/30">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-trek-cream/90 dark:bg-trek-forest/95"></div>
        <img
          src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?q=80&w=2000&auto=format&fit=crop"
          alt="Mountain backdrop"
          className="w-full h-full object-cover opacity-30 dark:opacity-20"
        />
      </div>

      <div className="container mx-auto max-w-6xl relative">
        <HeroContent regionTexts={regionTexts} />
        <div className="relative z-10">
          <HeroSearch />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
